import Big from 'big.js';

/**
 * 使用Big库解决js数字相加时出现的浮点数问题
 * @param target 将给定的数字或数组<数字>相加
 * @example {{0.1|add}} => 0.1
 * @example {{[0.1, 0.2]|add}} => 0.3	注意: 在JS中01+0.2=0.30000000000000004
 */

export default function (...value: any): number{
	const isNumber = (target: any): boolean => Object.prototype.toString.call(target) == '[object Number]';
	let numbers: Array<number> = value.map((num: any) => {
		return isNumber(Number(num)) ? Number(num) : 0;
	});
	return numbers
		.reduce((a: any, b: number) => {
			return a.plus(b);
		}, Big(0))
		.toFixed();
}
